import { HomePage } from 'home/pages';

import { homePath, logoHomePath } from './routePaths';

export const home = {
  path: homePath(),
  exact: true,
  isPrivate: false,
  element: <HomePage />,
};

export const logoHome = {
  path: logoHomePath(),
  exact: true,
  isPrivate: false,
  element: <HomePage logoHomePage />,
};
